import styled, { css } from 'styled-components';

import { Position, Grow, Width } from './types';

type MenuProps = {};
export const Menu = styled.div<MenuProps>`
  position: relative;
`;

type MenuDropdownProps = { position: Position; width: Width; grow: Grow };
export const MenuDropdown = styled.div<MenuDropdownProps>`
  position: absolute;
  width: ${p => p.width};
  background: ${p => p.theme.bg.primary};
  border: 1px solid ${p => p.theme.lines.primary};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  ${p =>
    p.position === 'right' &&
    css`
      left: 100%;

      ${p.grow === 'up' &&
        css`
          bottom: 0;
        `};

      ${p.grow === 'down' &&
        css`
          top: 0;
        `};
    `};

  ${p =>
    p.position === 'left' &&
    css`
      right: 100%;

      ${p.grow === 'up' &&
        css`
          bottom: 0;
        `};

      ${p.grow === 'down' &&
        css`
          top: 0;
        `};
    `};

  ${p =>
    p.position === 'bottom' &&
    css`
      top: 100%;

      ${p.grow === 'left' &&
        css`
          right: 0;
        `};

      ${p.grow === 'right' &&
        css`
          left: 0;
        `};
    `};
`;
